import { gql } from "@apollo/client";

export default gql`
  mutation saveComplianceProgram(
    $complianceProgramId: Int
    $organizationId: Int
    $title: String
    $dueDate: Date
    $startDate: Date
    $periodStartDate: Date
    $periodEndDate: Date
    $topicTemplates: [TopicTemplateComplianceRequirement]
    $assessmentTemplates: [AssessmentTemplateComplianceRequirement]
    $state: ComplianceProgramState
    $appliesTo: ComplianceProgramAppliesTo
    $appliesToTeams: [Int]
    $appliesToManagers: [Int]
    $appliesToUsers: [Int]
    $excludedUsers: [Int]
    $excludedHireDateAfter: Date
    $removeExcludedHireDateAfter: Boolean
    $recurrence: ComplianceProgramRecurrence
    $calibration: ComplianceProgramCalibrationType
    $ongoing: Boolean
    $startDateOffset: Int
    $startDateDueDateOffset: Int
    $startDatePeriodStartOffset: Int
    $startDatePeriodEndOffset: Int
    $scheduledReminders: [ProgramScheduledReminderInput]
    $steps: [ComplianceProgramStepInput]
  ) {
    createOrUpdateComplianceProgram(
      complianceProgramId: $complianceProgramId
      organizationId: $organizationId
      title: $title
      dueDate: $dueDate
      startDate: $startDate
      periodStartDate: $periodStartDate
      periodEndDate: $periodEndDate
      topicTemplates: $topicTemplates
      assessmentTemplates: $assessmentTemplates
      state: $state
      appliesTo: $appliesTo
      appliesToTeams: $appliesToTeams
      appliesToManagers: $appliesToManagers
      appliesToUsers: $appliesToUsers
      excludedUsers: $excludedUsers
      excludedHireDateAfter: $excludedHireDateAfter
      removeExcludedHireDateAfter: $removeExcludedHireDateAfter
      recurrence: $recurrence
      ongoing: $ongoing
      startDateOffset: $startDateOffset
      startDateDueDateOffset: $startDateDueDateOffset
      startDatePeriodStartOffset: $startDatePeriodStartOffset
      startDatePeriodEndOffset: $startDatePeriodEndOffset
      scheduledReminders: $scheduledReminders
      calibration: $calibration
      steps: $steps
    ) {
      complianceProgram {
        id
        state
      }
    }
  }
`;
